require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-rosetta-code-zeckendorf-number-representation.json") })
        }
      }, "path---coding-interview-prep-rosetta-code-zeckendorf-number-representation");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-rosetta-code-zeckendorf-number-representation!./.cache/json/coding-interview-prep-rosetta-code-zeckendorf-number-representation.json
// module id = 1921
// module chunks = 231608221292675